import { LeafMark } from "./LeafMark";

const PHRASES = ["People", "Care", "Beyond Borders"];

// One slow editorial marquee — the tagline, set in serif italic.
export const Marquee = () => {
    const Sequence = () => (
        <div className="flex items-center shrink-0" aria-hidden="true">
            {PHRASES.map((phrase, i) => (
                <span key={i} className="flex items-center shrink-0">
                    <span className="font-serif italic text-3xl sm:text-5xl text-forest/85 px-8 sm:px-14 whitespace-nowrap">
                        {phrase}
                    </span>
                    <LeafMark className="w-5 h-5 sm:w-7 sm:h-7 text-natural shrink-0" />
                </span>
            ))}
        </div>
    );

    return (
        <div
            data-testid="editorial-marquee"
            className="border-y border-pine/10 bg-white/60 py-7 sm:py-9 overflow-hidden"
            aria-label="People. Care. Beyond Borders."
        >
            <div className="marquee-track">
                <Sequence />
                <Sequence />
            </div>
        </div>
    );
};
